import { jwtDecode } from 'jwt-decode';

const tokenKey = 'token';
const refreshTokenKey = 'refreshToken';

function getToken() {
  return localStorage.getItem(tokenKey);
}

function getDecodedToken() {
  const token = localStorage.getItem(tokenKey);
  if (token) {
    const decoded = jwtDecode(token);
    return decoded;
  }
  return undefined;
}

function getRefreshToken() {
  return localStorage.getItem(refreshTokenKey);
}

function clearToken() {
  localStorage.removeItem(tokenKey);
}

function clearRefreshToken() {
  localStorage.removeItem(refreshTokenKey);
}

function setToken(value: string) {
  localStorage.setItem(tokenKey, value);
}

function setRefreshToken(value: string) {
  localStorage.setItem(refreshTokenKey, value);
}

function setAuthData(token: string, refreshToken: string) {
  setToken(token);
  setRefreshToken(refreshToken);
}

export const AuthToken = {
  getToken,
  getDecodedToken,
  getRefreshToken,
  clearToken,
  clearRefreshToken,
  setToken,
  setRefreshToken,
  setAuthData,
};
